import {DistanceProps} from 'modules/cities/types';
import useApiQuery from 'shared/hooks/use-api-query';
import companiesKeys from '../util/companies-keys';

const useCompanyDistances = (companyId: string) => {
  return useApiQuery<DistanceProps[]>({
    url: `/distances/companies/${companyId}`,
    queryKey: companiesKeys.distances(companyId),
  });
};

export default useCompanyDistances;
